import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TopbarInfoWrapper } from '@/pages/_base/TopbarInfoWrapper';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';

interface Props {
  children: React.ReactNode;
  type: string;
  required_owner_access?: boolean;
}

export function TabSettingsWorkspaceWrapper({ children, type, required_owner_access }: Props) {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);
  const { page_settings_workspace_current_tab, global_is_mobile } = use_slice_ui(['page_settings_workspace_current_tab', 'global_is_mobile']);

  const is_user_owner_of_workspace = workspace_current.user_id_owner == current_workspace_user.user_id;

  /*
   * EFFECTS
   */

  //+deps: required_owner_access, page_settings_workspace_current_tab, type
  use_effect(() => {
    if (!required_owner_access) return;
    if (is_user_owner_of_workspace) return;
    if (page_settings_workspace_current_tab != type) return;

    dispatch(
      LOCAL__ui_set_string({
        key: 'page_settings_workspace_current_tab',
        value: ESettingsWorkspaceTab.GENERAL,
        valid_values: Object.values(ESettingsWorkspaceTab),
      }),
    );
  }, [is_user_owner_of_workspace, required_owner_access, page_settings_workspace_current_tab, type]);

  /*
   * HTML
   */
  if (page_settings_workspace_current_tab != type) return <></>;
  if (required_owner_access && !is_user_owner_of_workspace) return <></>;

  return (
    <>
      <div
        className={`h-full bg-component  text-page-foreground flex flex-col text-left`}
        style={{ width: `${global_is_mobile ? '100%' : `calc(100vw - ${CONSTANTS__client.SIDEBAR_LEFT_WIDTH + 50}px)`}` }}
      >
        <TopbarInfoWrapper>
          <span className={`text-left px-4 ${md('bg-component border-b border-component-border pb-1', '')}`}>
            {t(i18n_page_settings_workspace.tabs[type].title)}
          </span>
        </TopbarInfoWrapper>
        <div className={`pb-2  ${md('overflow-auto px-2 bg-component', 'px-8')}`}>{children}</div>
      </div>
    </>
  );
}
